<template>
  <div ref="container" class="loading-wrapper text-center">
    <!-- Mode Upload / Progress Bar -->
    <div
      v-if="hasProgress"
      class="upload-overlay-backdrop d-flex align-items-center justify-content-center"
    >
      <div class="card shadow-lg border-0 upload-card p-4 text-center">
        <div class="mb-3">
          <div class="upload-icon-wrapper mx-auto mb-3">
            <i class="isax isax-document-upload fs-1 text-primary"></i>
          </div>
          <h4 class="fw-bold mb-1">{{ title }}</h4>
          <p class="text-muted small mb-0">
            {{ subtitle }}
          </p>
        </div>

        <!-- Progress Bar -->
        <div
          class="progress mb-2"
          style="height: 24px; border-radius: 12px; background-color: #e9ecef;"
        >
          <div
            class="progress-bar progress-bar-striped progress-bar-animated bg-primary fw-bold"
            role="progressbar"
            :style="{ width: normalizedProgress + '%' }"
            :aria-valuenow="normalizedProgress"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ normalizedProgress }}%
          </div>
        </div>

        <!-- Detail Info & Status Text -->
        <p v-if="statusText" class="fw-medium text-dark mb-3 small">
          {{ statusText }}
        </p>

        <div
          class="alert alert-warning py-2 px-3 mb-0 d-flex align-items-center text-start"
        >
          <i
            class="isax isax-info-circle me-2 fs-5 flex-shrink-0 text-warning"
          ></i>
          <small class="mb-0">
            Mohon <strong>jangan menutup atau me-refresh</strong> halaman ini
            sampai proses selesai.
          </small>
        </div>
      </div>
    </div>

    <!-- Mode Spinner Biasa -->
    <loading
      v-else
      :active="true"
      :is-full-page="true"
      :container="containerEl"
      :can-cancel="false"
      :loader="'spinner'"
      color="#007bff"
      :height="100"
      :width="100"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  name: "BaseLoading",
  components: {
    Loading,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false, // 'dialog' or 'inline'
    },
    progress: {
      type: [Number, null],
      default: null,
    },
    statusText: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Mengunggah Konten Course",
    },
    subtitle: {
      type: String,
      default: "File video / media sedang diunggah ke server.",
    },
  },
  data() {
    return {
      containerEl: null,
    };
  },
  computed: {
    hasProgress() {
      return this.progress !== null && this.progress !== undefined;
    },
    normalizedProgress() {
      if (typeof this.progress !== "number") return 0;
      return Math.min(100, Math.max(0, Math.round(this.progress)));
    },
  },
  mounted() {
    this.containerEl = this.$refs.container;
  },
};
</script>

<style scoped>
.loading-wrapper {
  position: relative;
  display: inline-block;
  min-height: 200px;
  min-width: 200px;
}
.vue-loading-overlay {
  z-index: 9999 !important;
}

.upload-overlay-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(5px);
  z-index: 10500;
  padding: 1rem;
}

.upload-card {
  width: 100%;
  max-width: 460px;
  border-radius: 18px;
  background-color: #ffffff;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25) !important;
  animation: fadeInScale 0.25s ease-out;
}

.upload-icon-wrapper {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: rgba(13, 110, 253, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
